import axios from 'axios';


export default {
    runScript: function(script, parameters) {
        var postData = {
            fieldData : {
            },
            script : script,
            parameters : parameters
        }
        return axios.post(`../../api/v1/runScript.php`, postData)
            .then((response)=>{
                return response.data
            })
            .catch((e)=>{
                if(e.response.data.messages[0].message){
                    //Return FM Error Response
                    return e.response.data
                }else{
                    //Format Unknown Error Like a FM Error
                    return  `{ messages:[message: ${e.message}, code: -1],response: {}}`;
                }
            })
    },
    downloadDocument: function(documentID){
        return axios.post(`downloadDocument.php`, documentID)
        .then((response) => {
            // success callback
            return response.data
        })
        .catch( (e) => {
            if(e.response.data.messages[0].message){
                //Return FM Error Response
                return e.response.data
            }
            else{
                //Format Unknown Error Like a FM Error   
                return  `{ messages:[message: ${e.message}, code: -1],response: {}}`
            }
        })
    },
    find: function(query, layout) {
        return axios.post(`find.php?layout=${layout}`, query)
        .then((response)=>{
            return response
        })
        .catch((e)=>{
            console.log(e)
            // if(e.response.data.messages[0].message){
            //     //Return FM Error Response
            //     return e.response.data
            // }else{
            //     //Format Unknown Error Like a FM Error
            //     return  `{ messages:[message: ${e.message}, code: -1],response: {}}`;
            // }
        })
    },
    log: function(postData) {
        return axios.post(`../../api/v1/log.php`, postData)
        .then((response)=>{
            return response.data
        })
        .catch((e)=>{
            console.log("Error creating log file")
            console.log(e)
        })
    },
    errorEmail: function(postData) {
        return axios.post(`../../api/v1/errorEmail.php`, postData)
        .then((response)=>{
            return response.data
        })
        .catch((e)=>{
            // if(e.response.data.messages[0].message){
            //     //Return FM Error Response
            //     return e.response.data
            // }else{
            //     //Format Unknown Error Like a FM Error
            //     return  `{ messages:[message: ${e.message}, code: -1],response: {}}`;
            // }
            console.error("Error sending email")
            return e
        })
    },
    logout: function() {
        return axios.post(`../../api/v1/logout.php`)
        .then((response)=>{
            return response.data
        })
        .catch((e)=>{
            return e
        })
    }
}